import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mega-menu',
    templateUrl: './mega-menu.component.html',
    standalone: false
})
export class MegamenuComponent implements OnInit {
  public value:boolean=false;
  constructor() { }

  ngOnInit() {
  }

  hideMegamenu(){
    this.value=!this.value;
  }
}
